module.exports = __webpack_public_path__ + "img/team_pending.b0c4e157.png";